<template>
  <div class="shot_photo_detail">

    <!-- swiper -->
    <div v-if="modulesShow.hasSwiper && goodsDetail.shotHeadImg && goodsDetail.shotHeadImg.length > 0" class="shot_photo_detail_swiper">
      <swiper :options="options" :activeIndex="activeIndex">
        <swiper-slide v-for="(m,i) in goodsDetail.shotHeadImg" :key="i" class="shot_photo_detail_swiper_slide">
          <img class="shot_photo_detail_swiper_slide_img" :src="m" alt="">
        </swiper-slide>
      </swiper>
      <div class="shot_photo_detail_count">
        <span>{{activeIndex}}</span>
        /
        <span>{{goodsDetail.shotHeadImg.length}}</span>
      </div>
    </div>

    <!-- name -->
    <div v-if="modulesShow.hasName" class="shot_photo_detail_box shot_photo_detail_name">
      {{goodsDetail.shotName}}
    </div>

    <!-- channel -->
    <div v-if="modulesShow.hasChannel" class="shot_photo_detail_box shot_photo_detail_channel">
      <div class="shot_photo_detail_channel_line">
        <span class="shot_photo_detail_channel_type">{{goodsDetail.shotWay.title}}</span>
        <span>{{goodsDetail.shotWay.content}}</span>
      </div>
    </div>

    <!-- number -->
    <div v-if="modulesShow.hasNumber" class="shot_photo_detail_box shot_photo_detail_channel">
      <div class="shot_photo_detail_channel_line">
        <span class="shot_photo_detail_channel_type">已选</span>
        <span>{{ goodsDetail.specInfo  }} 数量 x {{goodsDetail.shotNumber}}</span>
      </div>
    </div>

    <!-- detail -->
    <div v-if="modulesShow.hasDetail" class="shot_photo_detail_detail">
      <p class="shot_photo_detail_detail_title">商品详情</p>
      <div class="shot_photo_detail_detail_img_box">
        <img v-for="(m,i) in goodsDetail.shotBodyImg" :key="i" :src="m" alt="" class="shot_photo_detail_detail_img">
      </div>
    </div>
  </div>
</template>

<script>
import api from './api'
import apiGo from "./apiGo";
import service from './service'
import 'swiper/dist/css/swiper.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
let _this = null
export default {
  data() {
    return {
      shotId: 0,
      activeIndex: 1,
      options: {
        on: {
          slideChange () {
            _this.activeIndex = this.activeIndex + 1
          }
        }
      },
      pageSource: '', // 渠道-公
      modulesShow: { // 显示问题-公
        hasSwiper: false,
        hasName: false,
        hasChannel: false,
        hasNumber: false,
        hasDetail: false,
      },
      goodsDetail: { // 商品详情-公
        shotHeadImg: [],
        shotBodyImg: [],
        shotName: '',
        shotNumber: 1,
        shotWay: {title: '', content: ''},
        specInfo: ''
      },
      vipNormalDetailConfig: {}, // 会员普通商品-私
      orderId: '',
      openId: '',
      aliOrderNo: '', // 支付宝订单
      aliSpuId: null,
      orderType: ''
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  watch: {},
  created() {
    _this = this
  },
  mounted() {
    this.pageSource = this.$route.query.pageSource
    this.shotId = this.$route.query.shotId
    this.orderId = this.$route.query.orderId
    this.openId = this.$route.query.openId || ''
    this.orderType = this.$route.query.orderType
    this.aliOrderNo = this.$route.query.aliOrderNo
    //兼容积分商城多个商品的情况
    this.shotIndex = this.$route.query.shotIndex || 0
    this.getConfig()
  },
  methods: {
    // 商品快照配置-公
    async getConfig () {
      const {data} = await api.getShotPhotoConfig()
      console.log(data[this.pageSource])
      this.vipNormalDetailConfig = data[this.pageSource]
      this.modulesShow = this.vipNormalDetailConfig.modulesShow
      // 分渠道
      if (this.pageSource === 'vipNormalDetailConfig') {
        this.getVipNormalDetail()
      } else if (this.pageSource === 'vipNormalPointConfig') {
        this.getvipNormalPoint()
      } else if (this.pageSource === 'boxliteNormalOrderConfig') { // 会员抽盒
        this.getBoxliteOrderDetail()
      } else if (this.pageSource == 'vipAlipayNormalPointConfig') { //支付宝抽盒机
        this.getAliMainOrderDetail()
      }
    },

    // 商品快照详情接口-私
    async getVipNormalDetail () {
      let params = {
        // order_no: 'SG1687232460610896898-1', // 云店
        // order_no: 'SG1687232494988513902-2', // 急送
        // order_no: 'SG1687167579657894985-3', // 自提
        order_no: this.orderId, // 自提
        openid: this.openId,
      }
      params = service.creatSign(params)
      const {data:{order_detail}} = await apiGo.getStoreVipTrans(params)
      this.goodsDetail = service.vipNormalDetailService(order_detail, _this.shotId, this.vipNormalDetailConfig)
    },
    // 商品列表接口-私
    async getvipNormalPoint () {
      let params = this.orderType == 'aliPoint' ?
      {
        order_id: this.orderId, // 积分
        ali_user_id: this.openId,
      }: {
        order_id: this.orderId, // 积分
        openid: this.openId,
      }
      params = service.creatSign(params)
      const {data:{OrderDetail:{goods_list}}} = await apiGo.getPointShot(params)
      if (goods_list&&goods_list.length) this.goodsDetail = service.vipPointDetailService(goods_list,this.shotIndex)
    },
    async getBoxliteOrderDetail () {
      let params = {
        snapshot_id: this.shotId
      }
      params.identity_code = this.openId;
      params = service.creatSign(params);
      const { data } = await apiGo.getBoxliteOrderDetail(params);
      this.goodsDetail = service.boxliteNormalDetailService(data);
    },
    getAliMainOrderDetail(){
      let params = {
        order_no: this.aliOrderNo
      }
      api.getAlipayOrderPhoto(params).then(res=>{
        if (res.code === 1) {
          console.log(res, 'asdkadjasdjasodi')
          let detail = res.data;
          if (detail.id === 0) {
            this.modulesShow.hasName = false;
            this.modulesShow.hasNumber = false;
            this.$toast('2023年7月1日前订单暂不支持查看交易快照');
            return;
          }
          this.goodsDetail.shotHeadImg = detail.img.detail_head_imgs;
          this.goodsDetail.shotBodyImg = detail.img.detail_body_imgs;
          if (detail.goods_type === 'shop') {
            this.goodsDetail.shotName = detail.brand_name;
          } else {
            this.goodsDetail.shotName = detail.brand_name + detail.sku_name;
          }
          this.goodsDetail.shotName = detail.brand_name + detail.sku_name;
          this.goodsDetail.shotNumber = detail.count;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getAliChildOrderDetail(){

    }
  },
};
</script>

<style>
body {
  background-color: #F7F7F7;
}
.shot_photo_detail {
  padding-bottom: 70px;
}
  .shot_photo_detail_swiper {
    position: relative;
  }
  .shot_photo_detail_swiper_slide {
    height: 750px;
  }
  .shot_photo_detail_swiper_slide_img {
    width: 100%;
    height: 750px;
  }
  .shot_photo_detail_count {
    position: absolute;
    right: 32px;
    bottom: 24px;
    z-index: 900;
    width: 68px;
    height: 48px;
    background: rgba(0,0,0,0.3);
    border-radius: 24px;
    text-align: center;
    font-size: 24px;
    font-family: DINPro-Medium;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 48px;
  }
  .shot_photo_detail_box {
    width: calc(100% - 64px);
    margin: 0 auto;
    background: #FFFFFF;
    border-radius: 24px;
    padding: 40px 24px;
    margin-top: 24px;
  }
  .shot_photo_detail_name {
    font-size: 30px;
    font-weight: 500;
    word-break: break-all;
  }
  .shot_photo_detail_channel {
    font-size: 24px;

  }
  .shot_photo_detail_channel_line {
    height: 32px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 1;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .shot_photo_detail_channel_type {
    color: #999999;
    margin-right: 32px;
    width: 100px;
    display: inline-block;
  }
  .shot_photo_detail_detail {
    width: calc(100% - 64px);
    margin: 0 auto;
    background: #FFFFFF;
    border-radius: 24px;
    padding: 32px 0 40px 0;
    margin-top: 24px;
  }
  .shot_photo_detail_detail_title {
    font-size: 28px;
    margin-bottom: 32px;
    margin-left: 24px;
  }
  .shot_photo_detail_detail_img {
    width: 100%;
    display: block;
  }
  .shot_photo_detail_detail_img_box {
    overflow: hidden;
    border-radius: 24px;
  }
</style>
